import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { useQuery } from "@tanstack/react-query";
import { useMemo } from "react";
import { getDepartmentSchedules } from "../../api/department_schedule";

export const OnDutyRequestMemoList = ({ pivot }) => {
  // 当直・オンコール希望 = 9
  const scheduleTypeId = 9;

  const { data, refetch, isSuccess } = useQuery({
    queryKey: ["schedulesByOnDutyRequestType", pivot, scheduleTypeId],
    queryFn: () =>
      getDepartmentSchedules(
        pivot.format("YYYY"),
        pivot.format("MM"),
        scheduleTypeId,
      ),
    throwOnError: true,
  });

  const rows = useMemo(() => {
    if (!data) {
      return [];
    }
    return data
      .filter((d) => d.on_duty_comment)
      .map((s) => ({
        id: s.id,
        date: s.date,
        user: s.user.full_name,
        on_duty_comment: s.on_duty_comment,
      }));
  }, [data]);

  return rows.length > 0 ? (
    <Accordion>
      <AccordionSummary
        expandIcon={<ArrowDownwardIcon />}
        aria-controls="panel1-content"
        id="panel1-header"
      >
        <Typography>当直希望コメント</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <TableContainer component={Paper} sx={{ maxHeight: 440 }}>
          <Table sx={{ minWidth: 650 }} aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell>id</TableCell>
                <TableCell align="right">日付</TableCell>
                <TableCell align="right">医師</TableCell>
                <TableCell align="right">当直希望コメント</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {rows.map((row) => (
                <TableRow
                  key={row.id}
                  sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                >
                  <TableCell component="th" scope="row">
                    {row.id}
                  </TableCell>
                  <TableCell align="right">{row.date}</TableCell>
                  <TableCell align="right">{row.user}</TableCell>
                  <TableCell align="right">{row.on_duty_comment}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </AccordionDetails>
    </Accordion>
  ) : (
    <></>
  );
};
